import { Globals } from "../CoreApp/Globals";

export function getHoverTip(hoverCode) {
  let tooltip = hoverCode;
  if (Globals._stringMgr) tooltip = Globals._stringMgr.getHoverTip(hoverCode);
  return tooltip;
}
